export default __webpack_public_path__ + "static/media/item_5@3x.89a11f5e.webp";